import { render, staticRenderFns } from "./UpdateData.vue?vue&type=template&id=5291fd16&"
import script from "./UpdateData.vue?vue&type=script&lang=js&"
export * from "./UpdateData.vue?vue&type=script&lang=js&"
import style0 from "./UpdateData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports